import React from 'react';
import { Color } from '../../styles/colors';
type Props = {
  className?: string;
  color?: string;
};

const Separator = ({ className, color = Color.tertiary20 }: Props) => (
  <hr
    className={className || 'my-sm-24'}
    style={{
      border: 'none',
      width: '100%',
      height: 1,
      backgroundColor: color,
    }}
  />
);

type DotSeparatorProps = {
  margin?: number;
};
export const DotSeparator = ({ margin = 16 }: DotSeparatorProps) => <span className={`mx-sm-${margin}`}>•</span>;
export default Separator;
